import { APP_TIMEZONE } from '@qlk/shared';

/**
 * Tiện ích hiển thị kỳ `YYYY-MM` theo cách viết trong ảnh thiết kế.
 * Chuyển từ `modules/networks/ky.ts` về đây ở bước 12.2 vì module `revenue`
 * import chéo sang 6 chỗ.
 */

/** `2026-09` → `tháng 9/2026`. */
export function tenKy(period: string): string {
  const [nam, thang] = period.split('-');
  if (!nam || !thang) return '—';
  return `tháng ${String(Number(thang))}/${nam}`;
}

/** `2026-09` → `T9`, dùng cho nhãn ngắn trên thẻ. */
export function nhanKyNgan(period: string): string {
  const thang = period.split('-')[1];
  return thang ? `T${String(Number(thang))}` : '';
}

/** Kỳ của hôm nay theo giờ Việt Nam. */
export function kyHienTai(homNay = new Date()): string {
  const vn = new Date(homNay.toLocaleString('en-US', { timeZone: APP_TIMEZONE }));
  return `${String(vn.getFullYear())}-${String(vn.getMonth() + 1).padStart(2, '0')}`;
}

/** Danh sách `soThang` kỳ gần nhất, mới nhất đứng trước. */
export function cacKyGanDay(soThang = 12, homNay = new Date()): string[] {
  const vn = new Date(homNay.toLocaleString('en-US', { timeZone: APP_TIMEZONE }));
  return Array.from({ length: soThang }, (_, i) => {
    const d = new Date(vn.getFullYear(), vn.getMonth() - i, 1);
    return `${String(d.getFullYear())}-${String(d.getMonth() + 1).padStart(2, '0')}`;
  });
}
